<template>
  <layout>
    <template v-slot:header>กราฟแสดงรายได้รวม</template>
    <template v-slot:body>
      <b-row style="margin: 0.5rem 0 0.5rem 0">
        <b-col cols="auto"><p>ข้อมูลของปี</p></b-col>
        <b-col cols="3">
          <b-form-select v-model="year" :options="yearOptions"></b-form-select>
        </b-col>
      </b-row>
      <bar-chart
        :chart-data="data"
        :options="options"
        :height="300"
      ></bar-chart>
      <br>
      <div style="text-align: center" v-if="checkData">
        ไม่มีข้อมูล
      </div>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/pages/analytics/shared/Layout.vue";
import BarChart from "@/components/charts/BarChart.js";
import api from "@/services/api.js";
import moment from "moment";
import chartMockMixin from "@/mixins/chart-mock-mixin.js";
export default {
  mixins: [chartMockMixin],
  components: {
    BarChart,
    Layout
  },
  props: ["apiRoute"],
  data() {
    return {
      result: {},
      data: {},
      checkData: false,
      year: moment().format("YYYY"),
      yearOptions: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        plugins: {
          datalabels: {
            display: false
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: true
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: true
              },
              ticks: {
                callback: function(value) {
                  return value;
                },
                beginAtZero: true,
                maxTicksLimit: 20,
                min: 0
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    async fetch() {
      this.isBusy = true;
      let res = await api.get(this.apiRoute + `?year=${this.year}`);
      this.result = res.data;
      this.checkmockBarChart(res.data);
      this.checkData = this.label;
      this.data = {
        labels: [
          "มกราคม",
          "กุมภาพันธ์",
          "มีนาคม",
          "เมษายน",
          "พฤษภาคม",
          "มิถุนายน",
          "กรกฏาคม",
          "สิงหาคม",
          "กันยายน",
          "ตุลาคม",
          "พฤศจิกายน",
          "ธันวาคม"
        ],
        datasets: [
          {
            // Name the series
            data: Object.values(this.result).map(el => el), // Specify the data values array

            label: "",
            // Add custom color border (Line)
            backgroundColor: this.backgroundColor
          }
        ]
      };
      setTimeout(() => {
        this.isBusy = false;
      }, 1 * 1000);
    }
  },
  watch: {
    year() {
      this.fetch();
    }
  },
  async mounted() {
    if (this.yearOptions.length == 0) {
      let thisyear = moment().format("YYYY");
      for (let i = Number(thisyear); i >= 2014; i--)
        this.yearOptions.push({ value: i.toString(), text: i.toString() });
    }
    this.fetch();
  }
};
</script>
<style scoped>
p {
  font-family: "Prompt", sans-serif;
}
</style>
